import LoadableImage from "../LoadableImage";
import Navigation from "../Navigation";
import BackLink from "../BackLink";
import ForwardLink from "../ForwardLink";
import {useEffect} from "react";

function Page42() {
  useEffect(() => {
    document.title = "Маяк — Страница 41"
  }, []);

  return (
    <>
      <Navigation />

      <div className="NavigationLink-wrapper">
        <BackLink href="/page40" />
        <ForwardLink href="/page42" />
      </div>

      <p style={{ textAlign: "right" }}>41.</p>
      <p style={{ textAlign: "center" }}>
        СТАРИК (ПРОДОЛЖЕНИЕ)<br/>
        И последняя в этой смене,<br/>
        в жизни не видел инспектора, который<br/>
        бы не закрыл на этого глаза, и я<br/>
        отказа не приму.
      </p>
      <p>МОЛОДОЙ сдается. Он берет чашку.</p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        Пусть смерть бледная с тройным ужасом<br/>
        сделает... э-э...
      </p>
      <p>Пауза. Остальное он не помнит.</p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ (ПРОДОЛЖЕНИЕ)<br/>
        Тьфу, черт -- за смену!
      </p>
      <p>Они чокаются.</p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        И еще!
      </p>
      <p>Они выпивают.</p>
      <p>МОЛОДОЙ вспоминает, как ему не хватало выпивки.</p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        Черт! Будто вернулся домой.
      </p>
      <p>СТАРИК наливает еще по одной.</p>
      <p>Они выпивают.</p>
      <p>СТАРИК наливает еще по одной.</p>
      <p>Они выпивают.</p>
      <br/>
      <p>– ПОЗЖЕ</p>
      <p>МОЛОДОЙ И СТАРИК стучат по столу и поют.</p>
      <p style={{ textAlign: "center" }}>
        СТАРИК И МОЛОДОЙ<br/>
        (поют)<br/>
        Ура, мы возвращаемся домой,<br/>
        Ура, мы возвращаемся домой!
      </p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        (поет)<br/>
        Когда мы прибываем в доки Бедфорда,<br/>
        Эти юбки все собираются<br/>
        стаями,<br/>
        Эти красотки, мы слышим, как они говорят:<br/>
        "Вон идет Джек с девяти-<br/>
        месячной зарплатой"
      </p>
      <p style={{ textAlign: "right" }}>41.</p>

      <Navigation />

      <div className="NavigationLink-wrapper">
        <BackLink href="/page40" />
        <ForwardLink href="/page42" />
      </div>

      <LoadableImage
        src="https://res.cloudinary.com/linuxmachinecloud/image/upload/v1710314296/the-lighthouse-script/vidrsk5obfeoe4qtfwfj.jpg"
        alt="Иллюстрация"
      />
    </>
  );
}

export default Page42;
